/**
 * Inbox utility helpers — pure functions for sent-marker handling.
 *
 * Sent blocks carry a "→ path" line appended to their content
 * indicating which node the block was sent to.
 */

/**
 * Check if a block has been sent to a node.
 * @param {string} content - Full block content
 * @returns {boolean}
 */
export function isSent(content) {
  return /\n?→\s+\S+/.test(content);
}

/**
 * Extract the sent-target path from a block.
 * @param {string} content - Full block content
 * @returns {string|null} - Target path, or null if not sent
 */
export function getSentTarget(content) {
  const m = content.match(/→\s+(\S+)/);
  return m ? m[1] : null;
}

